import styled from 'styled-components'

export const H2 = styled.h2`
  margin-top: 45px;
`

export const H3 = styled.h3`
  margin-top: 65px;
`
